module.exports = __webpack_public_path__ + "img/introduce-icon4.cd5249b3.svg";